import React from 'react';
import OtpInput from 'react-otp-input';
import { Colors } from '../../theme';

const containerStyle = {
  gap: 12,
  justifyContent: 'center',
};

const inputStyle = {
  width: '3.25rem',
  height: '3.75rem',
  borderRadius: 12,
  border: `1.5px solid ${Colors.BORDER_ON_DARK}`,
  background: Colors.INPUT_ON_DARK,
  color: Colors.WHITE,
  fontSize: '1.5rem',
  fontWeight: 700,
  caretColor: Colors.GREEN_BACKGROUND,
  transition: 'border-color 160ms ease-out, background-color 160ms ease-out',
};

const focusStyle = {
  outline: 'none',
  borderColor: Colors.GREEN_BACKGROUND,
  background: Colors.INPUT_ON_DARK_FOCUS,
};

const errorStyle = {
  borderColor: Colors.ERROR_TEXT_LIGHT,
};

const disabledStyle = {
  opacity: 0.6,
};

function OtpInputField({
  handleChange, code, hasError, disabled,
}) {
  return (
    <OtpInput
      value={code}
      onChange={handleChange}
      numInputs={4}
      isInputNum
      shouldAutoFocus
      hasErrored={hasError}
      isDisabled={disabled}
      containerStyle={containerStyle}
      inputStyle={inputStyle}
      focusStyle={focusStyle}
      errorStyle={errorStyle}
      disabledStyle={disabledStyle}
    />
  );
}

export { OtpInputField };
